export default __webpack_public_path__ + "static/media/brand-image-10.c8bf41ea.jpg";